/**
 * The YubiKeys route path — a single flat screen, so there is only one path to name, unlike
 * `locations/paths.ts` and `support/paths.ts` which each also need a detail-path builder.
 */
export const yubikeysRoutePath = '/yubikeys';
